import consumer from "./consumer"

// Turbo fires turbo:load on the first page load as well as after every visit,
// so it is the only event listened to: subscribing on DOMContentLoaded too
// opened a second ConversationChannel subscription on every full load, and
// every visit added one more, never closed. Each broadcast then ran once per
// subscription, replacing the same message several times in a row.
document.addEventListener('turbo:load', () => {
  window.site.groupChat.init();
  window.site.groupChat.scrollToLastMessage();
});

// The page is about to be cached and left: its subscriptions go with it, and
// the next visit (or the restored snapshot's turbo:load) opens fresh ones.
document.addEventListener('turbo:before-cache', () => {
  window.site.groupChat.unsubscribeAll();
});

window.site = {
  ...window.site || {},
  groupChat: {
    subscriptions: new Map(),
    init() {
      window.site.groupChat.unsubscribeDetached();

      document.querySelectorAll('[data-channel-subscribe="conversation"]').forEach(element => {
        if (window.site.groupChat.subscriptions.has(element)) return;

        const conversation_id = element.dataset.conversationId;
        const subscription = consumer.subscriptions.create({ channel: "ConversationChannel", conversation_id: conversation_id }, {
          received: function(data) {
            const message = document.getElementById(`message-${data.message.slug}`);
            const html = data.message.user_id == gon.users.id ? data.sender : data.recipient;

            if (data.event === "create" && !message) {
              // Appended, not `innerHTML +=`: that reparsed every message
              // already shown and threw away their mounted components.
              element.insertAdjacentHTML('beforeend', html);
            } else if ((data.event === "update" || data.event === "destroy") && message) {
              message.innerHTML = html;
            } else {
              return;
            }

            window.mountComponents(window.components);
          }
        });

        window.site.groupChat.subscriptions.set(element, subscription);
      });
    },
    unsubscribeDetached() {
      window.site.groupChat.subscriptions.forEach((subscription, element) => {
        if (element.isConnected) return;

        subscription.unsubscribe();
        window.site.groupChat.subscriptions.delete(element);
      });
    },
    unsubscribeAll() {
      window.site.groupChat.subscriptions.forEach(subscription => subscription.unsubscribe());
      window.site.groupChat.subscriptions.clear();
    },
    // Instantly, like site.errors.reveal: an animated scroll runs on
    // animation frames, which may come only after the page has loaded, and
    // it moved the messages under a pointer already aimed at one of them.
    scrollToLastMessage() {
      const last_message = document.querySelector('.js-conversation-last-message');

      if (last_message) window.scrollTo(0, Math.max(site.getElementY(last_message) - 90 - 20, 0));
    }
  }
}
